import { FooterItem } from "@gravity-ui/navigation";
import { useAtom } from "@reatom/npm-react";
import cn from "classnames";
import { useLocation, useNavigate } from "react-router-dom";
import { RoutesPaths } from "src/routes/RoutesPaths.ts";
import { getServiceStatusAction } from "src/store/fetchers";

import {
  statusIcon,
  statusModifier,
} from "./ServiceStatusNavigationItem.constants.ts";
import css from "./ServiceStatusNavigationItem.module.scss";

interface ServiceStatusNavigationItemProps {
  compact: boolean;
}

export const ServiceStatusNavigationItem = ({
  compact,
}: ServiceStatusNavigationItemProps) => {
  const navigate = useNavigate();
  const { pathname: currentPath } = useLocation();

  const [serviceStatus] = useAtom(getServiceStatusAction.dataAtom);

  return (
    <div
      className={cn(
        css.serviceStatusButton,
        statusModifier[serviceStatus.overall],
      )}
    >
      <FooterItem
        compact={compact}
        item={{
          id: "service-status",
          title: "Статус сервисов",
          icon: statusIcon[serviceStatus.overall],
          current: currentPath.startsWith("/service-status"),
          onItemClick: () => navigate(RoutesPaths.LK.SERVICE_STATUS),
        }}
      />
    </div>
  );
};
